export enum _USER_REQUESTS_STORE {
  GET_USER_REQUESTS = 'UserRequestsStore/getUserRequestsA',
  SET_PENDING_USERS = 'UserRequestsStore/setPendingUsersM',
  SET_APPROVED_USERS = 'UserRequestsStore/setApprovedUsersM',
  SET_REJECTED_USERS = 'UserRequestsStore/setRejectedUsersM',
  RESET_USER_REQUESTS = 'UserRequestsStore/resetUserRequestsM'
}